import i18n from "i18n-js";
import memorize from "lodash.memoize";
import de from "./locales/de.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import no from "./locales/no.json";
import sv from "./locales/sv.json";

const translations = { en, de, fr, no, sv };

export const SUPPORTED_LOCALES = ["en", "de", "fr", "no", "sv"];

export const LANGUAGE_LABELS = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
  no: "Norsk",
  sv: "Svenska",
};

i18n.translations = translations;
i18n.defaultLocale = "en";
i18n.fallbacks = true;

// Migrate old 'nb' locale to 'no' (backward compatibility)
let savedLocale = localStorage.getItem("dashboard_locale");
if (savedLocale === "nb") {
  savedLocale = "no";
  localStorage.setItem("dashboard_locale", "no");
}

// Set initial locale from localStorage or fallback to 'en'
if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
  i18n.locale = savedLocale;
} else {
  i18n.locale = "en";
}

const translate = memorize(
  (key, config) => i18n.t(key, config),
  (key, config) => (config ? key + JSON.stringify(config) : key)
);

translate.cache.clear();

export function getLangToDisplay() {
  return i18n.locale;
}

export function strings(name, params) {
  return translate(name, params);
}

// Apply a locale synchronously without persisting it. `translate` memoizes on
// key+config only (not the locale), so a stale entry would survive a raw
// `i18n.locale = ...`; clearing the cache here is what actually makes the
// switch take effect. localeLoad layers persistence on top.
export function setLocaleSync(lang) {
  if (!SUPPORTED_LOCALES.includes(lang)) {
    lang = "en";
  }
  translate.cache.clear();
  i18n.locale = lang;
}

export const localeLoad = async (lang) => {
  setLocaleSync(lang);
  // Don't change defaultLocale - keep as 'en' so missing translations fall back to English
  localStorage.setItem("dashboard_locale", i18n.locale);
};

export default i18n;
